import type {
  DeviceCallResourceListResponseV2Api,
  EnumCallStatusApi as EnumCallStatusApiV2,
} from '@ingenico/api-sdk-device-management-private-v2';
import { enumCallStatus as enumCallStatusv2 } from '@ingenico/api-sdk-device-management-private-v2';
import type { DeviceCallResponse } from '@ingenico/react-ui';

export function computeStatus(status: EnumCallStatusApiV2): EnumCallStatusApiV2 {
  switch (status) {
    case enumCallStatusv2.FAILURE:
    case enumCallStatusv2.REJECTED:
    case enumCallStatusv2.SUCCESS:
    case enumCallStatusv2.SUSPENDED: {
      return status;
    }
    default: {
      return enumCallStatusv2.SUCCESS;
    }
  }
}

export function mapSearchDeviceCallsResponse(response: DeviceCallResourceListResponseV2Api): DeviceCallResponse {
  return {
    ...response,
    data: response.data.map((data) => ({
      ...data,
      status: computeStatus(data.status),
    })),
  };
}
